export default "__VITE_ASSET__dfd6a3f2__"